/* Intake classification only. This never grants trade access or sets a price. */
(() => {
  const contexts = {
    trade: { source: 'trade_partner_quote', en: 'Trade request: approval and trade pricing will be confirmed with your quote.', fr: 'Demande professionnelle : l’accès et le tarif seront confirmés au devis.' },
    bulk: { source: 'bulk_purchasing_request', en: 'Bulk request: include quantities, versions and destinations in your project notes.', fr: 'Demande groupée : précisez quantités, variantes et destinations dans vos notes.' },
  };
  const key = new URL(window.location.href).searchParams.get('programme');
  const context = Object.hasOwn(contexts, key) ? contexts[key] : null;
  if (!context) return;
  const initialize = () => {
    document.querySelectorAll('[data-ens-quote-form]').forEach(form => {
      if (form.dataset.programmeContext) return;
      const field = form.querySelector('input[name="form_source"]');
      if (!field) return;
      field.value = context.source;
      form.dataset.programmeContext = key;
      const notice = document.createElement('p');
      notice.className = 'ens-quote-helper';
      notice.setAttribute('role', 'note');
      notice.textContent = document.documentElement.lang.startsWith('fr') ? context.fr : context.en;
      form.prepend(notice);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
